import React, { FunctionComponent } from "react"

interface BotIconProps {}

const BotIcon: FunctionComponent<BotIconProps> = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.6667 7.33301H3.33333C2.59695 7.33301 2 7.92996 2 8.66634V12.6663C2 13.4027 2.59695 13.9997 3.33333 13.9997H12.6667C13.403 13.9997 14 13.4027 14 12.6663V8.66634C14 7.92996 13.403 7.33301 12.6667 7.33301Z" stroke="#2F373D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.00008 4.66667C8.73646 4.66667 9.33341 4.06971 9.33341 3.33333C9.33341 2.59695 8.73646 2 8.00008 2C7.2637 2 6.66675 2.59695 6.66675 3.33333C6.66675 4.06971 7.2637 4.66667 8.00008 4.66667Z" stroke="#2F373D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 4.66699V7.33366" stroke="#2F373D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<rect x="4.80005" y="10" width="1.6" height="1.6" rx="0.8" fill="#2F373D"/>
<rect x="9.6001" y="10" width="1.6" height="1.6" rx="0.8" fill="#2F373D"/>
</svg>
  )
}

export default BotIcon
